<template>
  <div class="order-region">
    <el-select
      :disabled="disabled"
      :style="styleUpdate"
      size="mini"
      placeholder="选择省"
      v-model="province"
      @change="changeProvince"
    >
      <el-option v-for="item in provinceList" :key="item" :label="item" :value="item"></el-option>
    </el-select>
    <el-select
      :disabled="disabled"
      :style="styleUpdate"
      size="mini"
      placeholder="选择市"
      v-model="city"
      @change="changeCity"
    >
      <el-option v-for="item in cityList" :key="item" :label="item" :value="item"></el-option>
    </el-select>
    <el-select
      :disabled="disabled"
      :style="styleUpdate"
      size="mini"
      placeholder="选择区"
      v-model="county"
      @change="changeCounty"
    >
      <el-option v-for="item in countyList" :key="item" :label="item" :value="item"></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OrderRegion',
  // model: {
  //   prop: "address",
  //   event: "change"
  // },
  props: {
    // 省市区地址
    address: {
      type: Array,
      default: () => []
    },
    styleUpdate: {
      type: Object,
      default: () => ({ width: '81px' })
    },
    disabled: Boolean,
  },
  data() {
    return {
      profile: {},
      cityList: [],// 省/市/区 - 城市列表
      countyList: [],// 省/市/区   --区域列表
      province: '',// 选择-省
      city: '',// 选择-市
      county: '',// 选择-区
    }
  },
  created() {
    this.profile = this.$common.getDealer();
  },
  watch: {
    address: {
      handler: function(val) {
        const isArray = Array.isArray(val)
        if (isArray && val.length) {
          const [province='', city='', county=''] = val ?? []
          this.province = province
          this.city = city
          this.county = county
          if (!this.cityList.length) {
            this.getCityList();
          }
          if (!this.countyList.length) {
            this.getCountyList();
          }
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('user', ['dealerProvinceData']),
    provinceList() {
      return [...this.dealerProvinceData]
    }
  },
  methods: {
    ...mapActions('user', ['getRegionList']),
    // 获取市区
    async getCityList() {
      this.cityList = await this.getRegionList({ province: this.province, city: "", dealerId: this.profile.dealerId })
    },
    // 获取区
    async getCountyList() {
      this.countyList = await this.getRegionList({ province: this.province, city: this.city, dealerId: this.profile.dealerId })
    },
    async changeProvince(provinceName) {
      this.cityList = [];// 清除市列表
      this.countyList = [];// 清除区域列表
      this.city = '';// 清除市
      this.county = '';// 清除区域
      if (provinceName) {
        await this.getCityList()
        this.city = this.cityList?.[0] ?? ''
        await this.getCountyList()
        this.county = this.countyList?.[0] ?? ''
      } else {
        // 清空省份
        this.province = ""
      }
      this.$emit('change', [this.province, this.city, this.county])
    },
    async changeCity(cityName) {
      this.countyList = [];// 清除区域列表
      this.county = '';// 清除区
      if (cityName) {
        // 获取区域列表
        await this.getCountyList()
        this.county = this.countyList?.[0] ?? ''
      } else {
        // 清空市区
        this.city = '';
      }
      this.$emit('change', [this.province, this.city, this.county])
    },
    changeCounty(countryName) {
      this.county = countryName;
      this.$emit('change', [this.province, this.city, this.county])
    },
  },
  beforeDestroy() {
    this.province = ''
    this.city = ''
    this.county = ''
    this.cityList = []
    this.countyList = []
  }
}
</script>
<style scoped>
::v-deep .el-select {
  display: inline-block;
  /* width: 81px; */
}
::v-deep .el-input--suffix .el-input__inner {
  padding-right: 20px;
}
</style>